import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "select-img"
};
const _hoisted_2 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
    class: "select_fill",
    src: $props.selectbox_img,
    fit: "fill"
  }, null, 8, _hoisted_2), _createElementVNode("div", {
    class: "button_box",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.gotoFunction && $options.gotoFunction(...args))
  }, [_createVNode(_component_el_image, {
    class: "select_fill",
    src: $data.buttonimg,
    fit: "fill"
  }, null, 8, ["src"])])]);
}